// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { testTemplateId } from './TestTemplate';
import { operatorId } from './Operator';
import { z } from 'zod';
export const testTemplateRevisionId = (z.number());
export const testTemplateRevision = z.object({
    id: testTemplateRevisionId,
    test_template_id: testTemplateId,
    is_draft: z.boolean(),
    previous_revision_id: testTemplateRevisionId.nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    is_correction_draft: z.boolean(),
    correction_source_revision_id: testTemplateRevisionId.nullable(),
});
export const testTemplateRevisionInitializer = z.object({
    id: testTemplateRevisionId.optional(),
    test_template_id: testTemplateId,
    is_draft: z.boolean().optional(),
    previous_revision_id: testTemplateRevisionId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    is_correction_draft: z.boolean().optional(),
    correction_source_revision_id: testTemplateRevisionId.optional().nullable(),
});
export const testTemplateRevisionMutator = z.object({
    id: testTemplateRevisionId.optional(),
    test_template_id: testTemplateId.optional(),
    is_draft: z.boolean().optional(),
    previous_revision_id: testTemplateRevisionId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    is_correction_draft: z.boolean().optional(),
    correction_source_revision_id: testTemplateRevisionId.optional().nullable(),
});
//# sourceMappingURL=TestTemplateRevision.js.map